var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPageNotFound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 404,
    height: 280,
    viewBox: "0 0 404 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76.511,
    cy: 37.069,
    r: 23.033,
    fill: "#E27370"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F4FA",
    d: "M188.578 123.489c0 54.348-32.31 73.325-72.165 73.325-39.856 0-72.165-18.977-72.165-73.325C44.248 69.14 116.413 0 116.413 0s72.165 69.14 72.165 123.489z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M113.784 188.5l.739-45.485 30.758-56.271-30.642 49.136.332-20.452 21.199-40.712-21.111 35.3.597-36.784 22.7-32.411-22.606 26.627L116.124 0l-2.347 89.289.193-3.683-23.079-35.327 22.71 42.397-2.151 41.081-.064-1.09-26.607-37.176 26.526 41.028-.269 5.138-.048.077.022.422-5.456 104.226h7.29l.874-53.835 26.46-40.928z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F4FA",
    d: "M403.298 145.748c0 44.487-26.447 60.02-59.07 60.02-32.624 0-59.071-15.533-59.071-60.02s59.07-101.081 59.07-101.081 59.071 56.594 59.071 101.081z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M342.076 198.963l.604-37.231 25.178-46.061-25.083 40.22.273-16.74 17.352-33.325-17.28 28.894.489-30.109 18.58-26.53-18.504 21.796.306-55.21-1.92 73.087.157-3.015-18.891-28.916 18.588 34.704-1.76 33.627-.052-.893-21.779-30.43 21.713 33.583-.22 4.206-.04.063.018.345-4.466 85.314h5.967l.716-44.066 21.66-33.502z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 199.596,
    cy: 244.902,
    fill: "#8261D8",
    opacity: 0.05,
    rx: 199.596,
    ry: 10.089
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 321.188,
    cy: 261.572,
    fill: "#8261D8",
    opacity: 0.05,
    rx: 34.186,
    ry: 1.728
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.483,
    cy: 278.242,
    fill: "#8261D8",
    opacity: 0.05,
    rx: 34.186,
    ry: 1.728
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.63,
    cy: 264.265,
    fill: "#8261D8",
    opacity: 0.05,
    rx: 78.103,
    ry: 3.948
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.94,
    cy: 203.799,
    r: 28.432,
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M21.722 225.958l8.637.102-.183 15.475-8.636-.102zM38.996 226.162l8.637.102-.183 15.474-8.637-.102z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.735,
    cy: 241.698,
    fill: "#2F2E41",
    rx: 2.699,
    ry: 7.198,
    transform: "rotate(-89.325 28.735 241.698)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.013,
    cy: 241.541,
    fill: "#2F2E41",
    rx: 2.699,
    ry: 7.198,
    transform: "rotate(-89.325 46.013 241.541)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.745,
    cy: 196.61,
    r: 9.717,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.745,
    cy: 196.61,
    r: 3.239,
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8261D8",
    d: "M7.674 177.035c-2.175-10.308 5.286-20.61 16.663-23.01 11.378-2.4 22.363 4.01 24.538 14.318 2.174 10.308-5.39 14.011-16.768 16.411-11.378 2.4-22.259 2.589-24.433-7.719z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2C4F6",
    d: "M78.31 219.66c0 19.822-11.782 26.743-26.318 26.743a42.941 42.941 0 0 1-3.008-.103c-13.12-.928-23.312-8.205-23.312-26.64 0-19.077 24.38-43.15 26.21-44.931l.004-.004c.07-.069.106-.102.106-.102S78.31 199.839 78.31 219.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M51.033 243.37l9.626-13.45-9.65 14.928-.026 1.544a42.941 42.941 0 0 1-2-.092l1.038-19.83-.008-.155.017-.029.098-1.873-9.674-14.964 9.705 13.56.022.397.784-14.983-8.282-15.464 8.383 12.834.816-31.064.004-.106v.102l-.137 24.496 8.246-9.71-8.28 11.82-.217 13.416 7.698-12.875-7.73 14.85-.122 7.457 11.177-17.92-11.219 20.523-.27 16.589z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.421,
    cy: 203.491,
    r: 28.432,
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M250.592 228.627l8.256-2.538 4.546 14.793-8.256 2.537zM267.104 223.553l8.257-2.537 4.546 14.793-8.257 2.537z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.071,
    cy: 241.477,
    fill: "#2F2E41",
    rx: 7.198,
    ry: 2.699,
    transform: "rotate(-17.083 262.071 241.477)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.478,
    cy: 236.058,
    fill: "#2F2E41",
    rx: 7.198,
    ry: 2.699,
    transform: "rotate(-17.083 278.478 236.058)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.995,
    cy: 196.4,
    r: 9.717,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.995,
    cy: 196.4,
    r: 3.239,
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8261D8",
    d: "M222.291 186.32c-5.215-9.154-1.252-21.24 8.851-26.996 10.104-5.756 22.521-3.002 27.736 6.151 5.215 9.154-.86 14.988-10.964 20.743-10.103 5.756-20.408 9.255-25.623.101z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2C4F6",
    d: "M205.714 216.03c0 18.196-10.816 24.55-24.16 24.55a41.524 41.524 0 0 1-2.76-.095c-12.043-.852-21.4-7.532-21.4-24.454 0-17.513 22.38-39.61 24.06-41.246l.003-.003.098-.094s24.16 23.147 24.16 41.343z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M180.674 237.796l8.837-12.347-8.859 13.702-.023 1.418a39.434 39.434 0 0 1-1.836-.084l.952-18.204-.007-.142.016-.026.09-1.72-8.88-13.736 8.908 12.447.02.365.72-13.754-7.602-14.195 7.695 11.78.75-28.515.002-.097v.094l-.125 22.487 7.57-8.915-7.6 10.852-.2 12.314 7.066-11.818-7.096 13.63-.112 6.847 10.26-16.45-10.298 18.839-.248 15.228z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2C4F6",
    d: "M300.727 223.62c0 19.82-11.783 26.742-26.319 26.742a42.941 42.941 0 0 1-3.008-.103c-13.119-.928-23.311-8.205-23.311-26.64 0-19.077 24.379-43.15 26.21-44.932l.003-.003c.07-.069.106-.102.106-.102s26.32 25.216 26.32 45.037z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M273.45 247.33l9.625-13.451-9.65 14.927-.026 1.545a42.941 42.941 0 0 1-2-.092l1.038-19.831-.008-.154.018-.029.098-1.873-9.675-14.964 9.705 13.56.023.397.784-14.984-8.283-15.463 8.384 12.834.816-31.065.003-.105v.102l-.136 24.496 8.245-9.71-8.279 11.82-.218 13.416 7.699-12.875-7.73 14.849-.123 7.458 11.177-17.92-11.219 20.523-.269 16.589z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.383,
    cy: 214.42,
    fill: "#2F2E41",
    rx: 4.463,
    ry: 14.216,
    transform: "rotate(-64.626 245.383 214.42)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.205,
    cy: 212.62,
    fill: "#2F2E41",
    rx: 4.463,
    ry: 14.216,
    transform: "rotate(-68.158 26.205 212.62)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFound);
export default __webpack_public_path__ + "static/media/page-not-found.ab318eb6a5c2fdc50ef3945f0a5bb3b8.svg";
export { ForwardRef as ReactComponent };